(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["staff-fitting"] && !Shopify.designMode) return;
  try {
    (() => {
    // GA4 is app-owned and may load after this script. Wait for it once per page
    // (up to 5s); if it never appears, all staff review events no-op.
    let gtagReady;
    const whenGtagReady = () => {
      if (!gtagReady) {
        gtagReady = new Promise((resolve) => {
          let attemptCount = 0;

          const check = () => {
            if (typeof window.gtag === 'function') {
              resolve(true);
              return;
            }

            attemptCount += 1;
            if (attemptCount < 20) {
              window.setTimeout(check, 250);
              return;
            }

            resolve(false);
          };

          check();
        });
      }

      return gtagReady;
    };

    const sendStaffReviewEvent = (eventName, parameters) => {
      whenGtagReady().then((ready) => {
        if (ready) window.gtag('event', eventName, parameters);
      });
    };

    const initializeStaffReviewAnalytics = (root = document) => {
      root.querySelectorAll('[data-staff-review-section]').forEach((section) => {
        if (section.dataset.staffReviewAnalyticsReady === 'true') return;

        section.dataset.staffReviewAnalyticsReady = 'true';
        const reviewCount = Number(section.dataset.reviewCount || 0);
        const viewTarget = section.querySelector('[data-staff-review-view-target]');

        if (viewTarget && 'IntersectionObserver' in window) {
          const viewObserver = new IntersectionObserver(
            (entries) => {
              entries.forEach((entry) => {
                if (!entry.isIntersecting || entry.intersectionRatio < 0.5) return;
                if (section.dataset.staffReviewViewTracked === 'true') return;

                section.dataset.staffReviewViewTracked = 'true';
                viewObserver.disconnect();
                sendStaffReviewEvent('staff_review_view', { review_count: reviewCount });
              });
            },
            { threshold: [0.5] },
          );

          viewObserver.observe(viewTarget);
        }

        section.querySelectorAll('[data-staff-review-entry]').forEach((entry) => {
          entry.addEventListener('toggle', () => {
            if (!entry.open || entry.dataset.staffReviewOpenTracked === 'true') return;

            entry.dataset.staffReviewOpenTracked = 'true';
            sendStaffReviewEvent('staff_review_open', {
              review_count: reviewCount,
              review_position: Number(entry.dataset.reviewPosition || 0),
            });
          });
        });
      });
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => initializeStaffReviewAnalytics(), { once: true });
    } else {
      initializeStaffReviewAnalytics();
    }

    document.addEventListener('shopify:section:load', (event) => initializeStaffReviewAnalytics(event.target));
  })();
  } catch(e) { console.error(e); }
})();

})();
